"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LateEntryIcon;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } // Generated by build-icons
// Do not edit by hand!
// @hash 48bf2f9684372b31c949e021c44137ebee5b3206
const svgElement = /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M2.171 8.327a.502.502 0 0 1-.354-.146 4.506 4.506 0 0 1 0-6.364 4.506 4.506 0 0 1 6.364 0 .5.5 0 0 1-.707.707 3.505 3.505 0 0 0-4.95 0 3.505 3.505 0 0 0 0 4.95.5.5 0 0 1-.353.853zM21.829 8.327a.5.5 0 0 1-.354-.853 3.505 3.505 0 0 0 0-4.95 3.505 3.505 0 0 0-4.95 0 .5.5 0 0 1-.707-.707 4.506 4.506 0 0 1 6.364 0 4.506 4.506 0 0 1 0 6.364.496.496 0 0 1-.353.146zM12 22.499c-5.238 0-9.5-4.262-9.5-9.5s4.262-9.5 9.5-9.5 9.5 4.262 9.5 9.5-4.262 9.5-9.5 9.5zm0-18c-4.687 0-8.5 3.813-8.5 8.5s3.813 8.5 8.5 8.5 8.5-3.813 8.5-8.5-3.813-8.5-8.5-8.5z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M16 16.499a.5.5 0 0 1-.299-.1l-4-3a.5.5 0 0 1-.2-.4v-7a.5.5 0 0 1 1 0v6.75l3.8 2.85a.5.5 0 0 1-.301.9zM5 23.499a.5.5 0 0 1-.354-.853l2-2a.5.5 0 0 1 .707.707l-2 2a.498.498 0 0 1-.353.146zM19 23.499a.502.502 0 0 1-.354-.146l-2-2a.5.5 0 0 1 .707-.707l2 2a.5.5 0 0 1-.353.853z"
}));
function LateEntryIcon(props) {
  return /*#__PURE__*/_react.default.createElement("span", _extends({
    className: "icon icon-late-entry"
  }, props), svgElement);
}